import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ib_logo from '../img/ib-circle-logo.png';
import { Notification, Link } from 'react-admin';
import { Box } from '@mui/material';

// Create styles directly with MUI sx prop instead of using userFormStyles
const RegisterSuccess = () => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'url(https://source.unsplash.com/random/1600x900/?abstract)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
        }}>
            <Card sx={{
                minWidth: 300,
                maxWidth: 500,
                marginTop: 2,
                marginBottom: 2,
                padding: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: 2
                }}>
                    <Typography variant="h5" gutterBottom>
                        Thank you
                    </Typography>
                </Box>
                <CardContent>
                    <Box sx={{ maxWidth: 400 }}>
                        <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }}>
                            <Link to={`/login`} style={{ color: 'grey' }}>
                                You can login here shortly
                            </Link>
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Your application for access has been received and is currently being reviewed. Once your application is approved, you will receive an email with instructions on how to set your password and gain access to the platform.
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            If you have any questions or concerns in the meantime, please don't hesitate to contact us.
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            Best regards,
                        </Typography>
                        <Typography variant="body2" gutterBottom>
                            InfoBate
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
            <Notification />
            <Box sx={{ position: 'absolute', bottom: 10, left: 10 }}>
                <img src={ib_logo} height='35px' alt='infobate-logo' />
            </Box>
        </Box>
    );
};

// We're keeping a simplified version of the themed wrapper for consistency
const RegisterSuccessWithTheme = () => (
    <RegisterSuccess />
);

export default RegisterSuccessWithTheme;

